import React from "react";
import {
  DUpdateLinks
} from "../../_metronic/_partials";
export function ULinks(props) {
  return  <DUpdateLinks {...props} />;
}
